import * as dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { z } from "zod";
import "dayjs/locale/en-nz";

export const LOCALE = "en-nz";

dayjs.locale(LOCALE);
dayjs.extend(localizedFormat);

export const dayjsSchema = z.custom<dayjs.Dayjs>(
  (val) => dayjs.isDayjs(val),
  "Invalid date",
);
